import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LiveChatService {

	private chatEnabledSubject = new BehaviorSubject<boolean>(false);
	chatEnabled$: Observable<boolean> = this.chatEnabledSubject.asObservable();

	private hideChatSubject = new BehaviorSubject<boolean>(false);
	hideChat$: Observable<boolean> = this.hideChatSubject.asObservable();

	enableChat(): void {
		this.chatEnabledSubject.next(true);
	}

	disableChat(): void {
		this.chatEnabledSubject.next(false);
	}

	hideChat(): void {	
		this.hideChatSubject.next(true);
	}

	resetHideChat(): void {
		this.hideChatSubject.next(false);
	}
}